// extracted by mini-css-extract-plugin
export default {"DrawerHeader":"styles_DrawerHeader__jkOmu","lineBar":"styles_lineBar__I+6Ll","DeliveryHeader":"styles_DeliveryHeader__h+xUM","divider":"styles_divider__M7JEZ"};